//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_feedback",
    data() {
        return {
            title: "异常反馈",
            record_type:'', //查询结果类型
            security_code: this.$route.query.security_code, //防伪码
            record_id: "", // 查询结果ID
            feedback_type: "", //异常类型 2我的积分被别人冒领 3防伪码不存在或无效
            remark: "", //备注
            media_id: "", //防伪码照片 微信临时文件id
            url: window.location.href, //当前地址
            localId: require("./image/add.png"),
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_inquire();
            this.get_conf();
        }
    },

    methods: {
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url,function() {
                self.get_inquire();
                self.get_conf();
            }); //获取token
        },

        //获取查询信息
        get_inquire(){
            var inquireResult=JSON.parse(sessionStorage.getItem('inquireResult'));
            this.record_type=inquireResult.data.business_data.record_type;
            this.record_id=inquireResult.data.business_data.record_id;
            if(this.record_type==2){
                this.feedback_type = 3; //查询结果为2 默认为3防伪码不存在或无效
            }else{
                this.feedback_type=2; //默认为2积分被冒领
            }
        },
        //提交
        submit() {
            var self = this;
            this.$EpetJs.Common.post("public/feedbacks", {
                record_type: this.record_type,
                record_id: this.record_id,
                security_code: this.security_code,
                feedback_type: this.feedback_type,
                remark: this.remark,
                media_id: this.media_id
            }).then(({ data }) => {
                if (data.status_code == "200") {
                    self.$vux.toast.text("反馈成功");
                    self.$router.push({name: "alliance_result",query: {security_code:this.security_code}});
                } else {
                    self.$vux.toast.text(data.message);
                }
            });
        },
        get_conf() {
            //微信js授权config
            var self = this;
            this.$EpetJs.Common.get_conf(this.url, function(res) {
                self.$wx.config(res);
                self.$wx.error(function(res) {
                    alert("出错了：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
                });
            });
        },
        //上传图片
        upload() {
            var self = this;
            this.$wx.chooseImage({
                count: 1, // 默认9
                sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
                success: function(res) {
                    // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    self.localId = res.localIds[0];
                    if (res.localIds[0] == "") {
                        alert("没有选中任何图片");
                    } else {
                        //选择正确，上传图片
                        //苹果手机中预览图片
                        if (window.__wxjs_is_wkwebview) {
                            self.getLocal(res.localIds[0]);
                        }
                        self.upImg(res.localIds[0]);
                    }
                }
            });
        },
        //预览图片接口
        getLocal(localId) {
            var self = this;
            this.$wx.getLocalImgData({
                localId: localId, // 图片的localID
                success: function(res) {
                    self.localId = res.localData; //localData是图片的base64数据，可以用img标签显示
                }
            });
        },

        //具体上传图片
        upImg(localId) {
            var self = this;
            this.$wx.uploadImage({
                localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function(res) {
                    self.media_id = res.serverId;
                },
                fail: function(res) {
                    alert(JSON.stringify(res));
                }
            });
        }
    }
};
